import React, { useEffect } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { updateOrderAction } from '../../../../services/request';
import { updateOrder } from '../../../../services/redux-actions';
import { Box, Tabs, Tab, Button, Badge } from '@mui/material';
import Scrollbar from '../../../../components/Scrollbar';
import OrderTab from './tabs/OrderTab/OrderTab';
import WRReservationDataForm from './tabs/ReservationDataTab/WRReservationDataForm';
import DocumentsAndNotifications from './tabs/DocumentAndNotificationsTab/DocumentsAndNotifications';
import SettlementTab from './tabs/SettlementTab/SettlementTab';
import ChangeHistory from './tabs/ChangeHistoryTab/ChangeHistory';
import Iconify from '../../../../components/Iconify';
import { WRReservationDetails } from './tabs/WRReservationTab/WRReservationDetails';
import toast from 'react-hot-toast';

const tabInputs = {
  orderTab: ['identifier', 'participant_name', 'participant_street_address', 'participant_postal_code', 'participant_city', 'guardian_name', 'guardian_correspondence_email', 'guardian_street_address', 'guardian_postal_code', 'guardian_city'],
  settlementTab: ['contractor_name', 'contractor_street_address', 'contractor_postal_code', 'contractor_city', 'contractor_correspondence_email']
};

const validationSchema = Yup.object({
  identifier: Yup.string().required('To pole nie może być puste'),
  created_at: Yup.date().required('To pole nie może być puste'),
  guardian_name: Yup.string().required('To pole nie może być puste'),
  guardian_correspondence_email: Yup.string().email('Proszę podać poprawny adres e-mail'),
  guardian_street_address: Yup.string().required('To pole nie może być puste'),
  guardian_postal_code: Yup.string().required('To pole nie może być puste'),
  guardian_city: Yup.string().required('To pole nie może być puste')
  // guardian_pesel: Yup.string().required('To pole nie może być puste')
});


export const WRFullScreenView = ({ updateOrders, refFormik }) => {
  const dispatch = useDispatch();
  const { order } = useSelector(state => state.orderData);
  const { loading, mutate } = useMutation(updateOrderAction);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [validationErros, setValidationErrors] = React.useState({ orderTab: false, settlementTab: false });

  const handleSubmit = async (orderId, values) => {
    const { error, payload } = await mutate(orderId, values);
    if (!error) {
      const clone = structuredClone(values);
      clone.activities = payload.activities;
      clone.final_payment_date = payload.final_payment_date;
      clone.advance_payment_date = payload.advance_payment_date;
      clone.positions = payload.products.map(p => ({ status: 'OLD', ...p }));
      clone.promotions = payload.promotions_object;
      formik.resetForm({
        values: clone
      });
      dispatch(updateOrder(payload));
      updateOrders(payload);
      toast.success('Zaktualizowano dane zamówienia');
    } else {
      // eslint-disable-next-line no-lonely-if
      if (_.isArray(payload)) {
        toast.error(payload[0]);
      } else {
        toast.error('Nie udało się zapisać zmian');
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      // OrderTab
      identifier: _.isNil(order.identifier) ? '' : order.identifier,
      created_at: _.isNil(order.created_at) ? '' : order.created_at,
      resort: _.isNil(order.resort) ? '' : order.resort,
      period: _.isNil(order.period) ? '' : order.period,
      period_from: _.isNil(order.period_from) ? '' : order.period_from,
      period_to: _.isNil(order.period_to) ? '' : order.period_to,
      guardian_name: _.isNil(order.guardian_name) ? '' : order.guardian_name,
      guardian_nip: _.isNil(order.guardian_nip) ? '' : order.guardian_nip,
      guardian_phone: _.isNil(order.guardian_phone) ? '' : order.guardian_phone,
      guardian_additional_phone: _.isNil(order.guardian_additional_phone) ? '' : order.guardian_additional_phone,
      guardian_correspondence_email: _.isNil(order.guardian_correspondence_email) ? '' : order.guardian_correspondence_email,
      guardian_street_address: _.isNil(order.guardian_street_address) ? '' : order.guardian_street_address,
      guardian_postal_code: _.isNil(order.guardian_postal_code) ? '' : order.guardian_postal_code,
      guardian_city: _.isNil(order.guardian_city) ? '' : order.guardian_city,
      guardian_pesel: _.isNil(order.guardian_pesel) ? '' : order.guardian_pesel,
      optional_activity_count_1: _.isNil(order.optional_activity_count_1) ? null : order.optional_activity_count_1,
      optional_activity_count_2: _.isNil(order.optional_activity_count_2) ? null : order.optional_activity_count_2,
      optional_activity_count_3: _.isNil(order.optional_activity_count_3) ? null : order.optional_activity_count_3,
      // ReservationDataForm
      rodo_terms: order.rodo_terms,
      other_terms: order.other_terms,
      marketing_consents_email: order.marketing_consents_email,
      marketing_consents_sms: order.marketing_consents_sms,
      marketing_consents_phone: order.marketing_consents_phone,
      source_of_offer: _.isNil(order.source_of_offer) ? '' : order.source_of_offer,
      form_of_communication: _.isNil(order.form_of_communication) ? '' : order.form_of_communication,
      return_of_health_card: order.return_of_health_card,
      no_return_of_card: order.no_return_of_card,
      no_return_of_card_description: _.isNil(order.no_return_of_card_description) ? '' : order.no_return_of_card_description,
      return_agreement: order.return_agreement,
      // annex_return: order.annex_return,
      accommodated: order.accommodated,
      family_card_number: _.isNil(order.family_card_number) ? '' : order.family_card_number,
      provisions: _.isNil(order.provisions) ? '' : order.provisions,
      road_distance_to_school: _.isNil(order.road_distance_to_school) ? null : order.road_distance_to_school,
      without_photos: _.isNil(order.without_photos) ? '' : order.without_photos,
      // WRReservationDetails
      wr_adults_count: _.isNil(order.wr_adults_count) ? '' : order.wr_adults_count,
      wr_3_12_children_age: _.isNil(order.wr_3_12_children_age) ? [] : order.wr_3_12_children_age,
      wr_0_3_children_age: _.isNil(order.wr_0_3_children_age) ? [] : order.wr_0_3_children_age,
      wr_6_plus_children_age: _.isNil(order.wr_6_plus_children_age) ? [] : order.wr_6_plus_children_age,
      wr_0_5_children_age: _.isNil(order.wr_0_5_children_age) ? [] : order.wr_0_5_children_age,
      // DocumentsAndNotifications
      automatic_notifications: order.automatic_notifications,
      manual_notifications: order.manual_notifications,
      coordinator_teacher_mail: _.isNil(order.coordinator_teacher_mail) ? '' : order.coordinator_teacher_mail,
      accomodation_teacher_mail: _.isNil(order.accomodation_teacher_mail) ? '' : order.accomodation_teacher_mail,
      teacher_mail_p8: _.isNil(order.teacher_mail_p8) ? '' : order.teacher_mail_p8,
      trip_teacher_mail: _.isNil(order.trip_teacher_mail) ? '' : order.trip_teacher_mail,
      // SettlementTab
      contractor_name: _.isNil(order.contractor_name) ? '' : order.contractor_name,
      contractor_nip: _.isNil(order.contractor_nip) ? '' : order.contractor_nip,
      contractor_phone: _.isNil(order.contractor_phone) ? '' : order.contractor_phone,
      contractor_correspondence_email: _.isNil(order.contractor_correspondence_email) ? '' : order.contractor_correspondence_email,
      contractor_street_address: _.isNil(order.contractor_street_address) ? '' : order.contractor_street_address,
      contractor_postal_code: _.isNil(order.contractor_postal_code) ? '' : order.contractor_postal_code,
      contractor_city: _.isNil(order.contractor_city) ? '' : order.contractor_city,
      invoice: '',
      advance_payment_date: _.isNil(order.advance_payment_date) ? null : order.advance_payment_date,
      final_payment_date: _.isNil(order.final_payment_date) ? null : order.final_payment_date,
      manual_payment_dates: order.manual_payment_dates,
      is_invoice_issued: order.is_invoice_issued,
      is_invoice_paid: order.is_invoice_paid,
      accounting_notes: _.isNil(order.accounting_notes) ? '' : order.accounting_notes,
      automatic_advance_reminder_notifications: _.isNil(order.automatic_advance_reminder_notifications) ? true : order.automatic_advance_reminder_notifications,
      without_director: _.isNil(order.without_director) ? false : order.without_director,
      way_of_sending_contract: _.isNil(order.way_of_sending_contract) ? '' : order.way_of_sending_contract,
      want_invoice: order.want_invoice,
      zs_special_diet: _.isNil(order.zs_special_diet) ? false : order.zs_special_diet,
      zs_special_diet_info: _.isNil(order.zs_special_diet_info) ? '' : order.zs_special_diet_info,
      positions: _.isNil(order.products) ? [] : order.products.map(p => ({ status: 'OLD', ...p })),
      wr_diets_json: _.isNil(order.wr_diets_json) ? {} : order.wr_diets_json,
      wr_activities_json: _.isNil(order.wr_activities_json) ? {} : order.wr_activities_json,
      wr_has_animal: order.wr_has_animal,
      wr_animal_info: _.isNil(order.wr_animal_info) ? '' : order.wr_animal_info,
      promotions: order.promotions_object || [],
      comments: _.isNil(order.comments) ? '' : order.comments,
      reservation_notes: _.isNil(order.reservation_notes) ? '' : order.reservation_notes,
      quick_payment_promotion: order.quick_payment_promotion
    },
    validationSchema,
    validateOnChange: true,
    onSubmit: values => {
      if (_.filter(values.activities, v => v.label.toLowerCase().includes('paintball')).length > 0 && values.paintball_participants_count == 0) {
        toast.error('Wybierając zajęcie paintballowe należy podać liczbę uczestników większą od 0');

        return;
      }
      if (_.filter(values.activities, v => v.label.toLowerCase().includes('paintball')).length == 0 && values.paintball_participants_count > 0) {
        toast.error('Podając liczbę uczestników gry paintballowej większą od 0, należy wybrać również zajęcie gry paintballowej');

        return;
      }
      if (_.isObject(values.period)) {
        values.period = values.period.value;
      }
      if (_.isObject(values.accomodation)) {
        values.accomodation = values.accomodation.value;
      }
      if (typeof values.educational_trip === 'object' && values.educational_trip !== null && !Array.isArray(values.educational_trip)) {
        values.educational_trip = [values.educational_trip.value];
      } else if (!_.isArray(values.educational_trip)) {
        values.educational_trip = [values.educational_trip];
      }
      values.promotions = _.map(
        values.promotions,
        o => o.value
      );
      handleSubmit(order.id, values);
    }
  });

  useEffect(() => {
    let orderTabCount = 0;
    let settlementTabCount = 0;

    if (!_.isEmpty(formik.errors)) {
      const keys = Object.keys(formik.errors);

      for (const key of keys) {
        if (tabInputs.orderTab.includes(key)) {
          orderTabCount++;
        } else if (tabInputs.settlementTab.includes(key)) {
          settlementTabCount++;
        }
      }

      toast.error('Upewnij się czy wszystkie pola zostały poprawnie wypełnione');
    }

    if (orderTabCount > 0) {
      setValidationErrors(prev => ({ ...prev, orderTab: true }));
    } else {
      setValidationErrors(prev => ({ ...prev, orderTab: false }));
    }

    if (settlementTabCount > 0) {
      setValidationErrors(prev => ({ ...prev, settlementTab: true }));
    } else {
      setValidationErrors(prev => ({ ...prev, settlementTab: false }));
    }
  }, [formik.errors]);

  refFormik.current = formik;

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Tabs sx={{ ml: 1 }} value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
          <Tab
            label="zamówienie"
            icon={<Badge color="error" variant="dot" invisible={!validationErros.orderTab}><Iconify icon={'icon-park-outline:transaction-order'} width={20} height={20} /></Badge>} />
          <Tab label="dane rezerwacji" icon={<Iconify icon={'ri:hotel-fill'} width={20} height={20} />} />
          <Tab label="szczegóły wyjazdu" icon={<Iconify icon={'ic:baseline-directions-bus'} width={20} height={20} />} />
          <Tab label="dokumenty i powiadomienia" icon={<Iconify icon={'mdi:file-document-multiple'} width={20} height={20} />} />
          <Tab
            label="rozliczenia"
            icon={<Badge color="error" variant="dot" invisible={!validationErros.settlementTab}><Iconify icon={'mdi:currency-usd'} width={20} height={20} /></Badge>} />
          <Tab label="historia zmian" icon={<Iconify icon={'mdi:clipboard-text-clock'} width={20} height={20} />} />
        </Tabs>
        <Box sx={{ mt: 2, mb: 2 } } display="flex" justifyContent="center" alignItems="center">
          <Button
            variant="contained"
            disabled={!formik.dirty || loading}
            onClick={formik.handleSubmit}
            sx={{ width: '50%' }}
          >
            Zapisz zmiany
          </Button>
        </Box>
      </Box>
      <Scrollbar>
        { currentTab === 0
          ? <OrderTab
            formik={formik}
          />
          : currentTab === 1
            ? <WRReservationDataForm
              formik={formik}
            />
            : currentTab === 2
              ? <WRReservationDetails
                order={order}
                formik={formik}
              />
              : currentTab === 3
                ? <DocumentsAndNotifications
                  updateOrders={updateOrders}
                  formik={formik}
                />
                : currentTab === 4
                  ? <SettlementTab
                    formik={formik}
                  />
                  : currentTab === 5
                    ? <ChangeHistory />
                    : null}
      </Scrollbar>
    </>
  );
};
